import React from 'react';

export default function SupportPage() {
  return (
    <main
      className="min-h-screen bg-app-background flex items-center justify-center px-5 py-10"
      data-testid="support-page"
    >
      <section className="w-full max-w-lg rounded-2xl border border-stone-200 bg-white p-7 shadow-sm sm:p-9">
        <div className="mb-8 flex justify-center">
          <img
            src="/brand/restaurantos-logo-horizontal.svg"
            alt="RestaurantOS"
            className="h-12 w-auto sm:h-14"
          />
        </div>

        <div className="text-center">
          <h1 className="font-display text-3xl font-bold tracking-tight text-brand-navy">
            Assistenza RestaurantOS
          </h1>
          <p className="mt-4 text-base leading-relaxed text-stone-600">
            Hai bisogno di assistenza con RestaurantOS? Contattaci e ti aiuteremo.
          </p>
          <a
            className="mt-6 inline-flex min-h-11 items-center justify-center rounded-xl bg-brand-green px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-green-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-green focus-visible:ring-offset-2"
            href="mailto:ozayermatubber59@gmail.com"
            data-testid="support-email"
          >
            ozayermatubber59@gmail.com
          </a>
          <p className="mt-5 text-sm text-stone-500">
            <a className="font-semibold text-brand-green underline-offset-4 hover:underline" href="/privacy">
              Informativa sulla privacy
            </a>
          </p>
        </div>
      </section>
    </main>
  );
}
